"use strict";
// Build out our basic SafeString type
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = function() {
  return "" + this.string;
};

exports["default"] = SafeString;


//////////////////
// WEBPACK FOOTER
// /work/node_modules/handlebars/dist/cjs/handlebars/safe-string.js
// module id = 10
// module chunks = 0 1 2